import React, { useState, useEffect } from 'react';

import { Spinner } from 'triider-components';

import { colors } from 'stylesheets';

import { gaSendEvent } from '../../../../utils/analytics';

import {
  DocumentBackground,
  DocumentContainer,
  DocumentHeader,
  DownloadButton,
  TextColor,
  Document,
} from './styles';

const DocumentTab = ({ invoice, paymentTicket }) => {
  const type = invoice || paymentTicket;

  const [loading, setLoading] = useState(true);

  const environment = (data) => {
    const url = data.file_url || data.invoice_url;
    return process.env.NODE_ENV === 'production'
      ? url
      : url && url.replace(/^https:\/\//i, 'http://');
  };

  useEffect(() => {
    setLoading(false);
  }, [type]);

  const handleDownload = (key) => {
    gaSendEvent('baixar_boleto', 'boletos');
    const url = type[key].file_url || type[key].invoice_url;
    window.open(url, '_blank');
  };

  const formatAmount = (amount) => {
    if (amount && amount > 0) {
      return amount.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        style: 'currency',
        currency: 'BRL',
      });
    }
    return '--';
  };

  const handleRender = (data, key) => (
    <DocumentBackground key={key}>
      {data && !data.file_url && (
        <DocumentHeader>
          <TextColor color={colors.primary}>{formatAmount(data.amount)}</TextColor>
          <DownloadButton onClick={() => handleDownload(key)}>BAIXAR BOLETO</DownloadButton>
        </DocumentHeader>
      )}
      <Document
        src={
          data.file_url
            ? `https://docs.google.com/gview?url=${environment(data)}&embedded=true&widget=true&headers=true`
            : data.invoice_url
        }
        frameBorder="0"
        allowfullscreen
      />
    </DocumentBackground>
  );

  return (
    <DocumentContainer loading={loading ? 'true' : 'false'}>
      {loading ? (
        <Spinner size="larger" />
      ) : (
        type && type.map((data, key) => handleRender(data, key))
      )}
    </DocumentContainer>
  );
};

export default DocumentTab;
